import { useSelector } from 'react-redux'
import store, { RootState } from '~/store'
import { setGeneralDiffComment } from '~/store/editorSlice'
import { useConversationUuid } from '../../../../hooks/conversation/useConversationUuid'

export function useGeneralReviewComment() {
  const conversationUuid = useConversationUuid()
  const review = useSelector((state: RootState) => state.editor.reviews[conversationUuid])
  const setState = (uuid: string, comment: string) => {
    store.dispatch(setGeneralDiffComment({ uuid, generalDiffComment: comment }))
  }
  return [review?.generalDiffComment ?? '', setState] as const
}
